export const QuestionGroup = 'QuestionGroup';
export const Execution = 'Execution';
export const Party = 'Party';
export const PartyGroup = 'PartyGroup';
export const ExecutionPlanGroup = 'ExecutionPlanGroup';
export const ProgrammeGroup = 'ProgrammeGroup';
